<template>
    <div class="ruler-wrp">
        <!--Dummy header for background-->
        <div class="ruler-background-fill">

        </div>

        <!-----------------
        | BUTTONS LEFT
        ------------------>
        <div class="ruler-controls controls-left">

            <div class="ruler-control-btn" v-on:mousedown="zoomclick(-50)" v-on:mouseup="zoomup()">
                <i class='icon icon-zoom-out'></i>
                <span><translate item="TimelineSettings.ModifyTime.Zoom" /></span>
            </div>

            <div class="ruler-control-btn ruler-btn-clock" v-on:click="setAutoscroll()">
                <span><i class='icon icon-clock'></i></span>
            </div>

            <div class="ruler-control-btn" v-on:mousedown="zoomclick(+50)" v-on:mouseup="zoomup()">
                <i class='icon icon-zoom-in'></i>
                <span><translate item="TimelineSettings.ModifyTime.Zoom" /></span>
            </div>

        </div>

        <!-----------------
        | THE RULER /TIMELINE
        ------------------>
        <div class="ruler vert-scroll" :style="styleProp">
            <!--Dummy header for background-->
            <div class="ruler-background">

            </div>
            <div class="time-tick" v-for="marker in Markers" :key="marker.x" :style="{left: marker.x + '%'}">
                <span class="time-hour">{{marker.caption.substring(0,3)}}<span class="time-minutes">{{marker.caption.substring(3,5)}}</span></span>
            </div>

            <div class="day time-tick" :style="{left: DayTick.x + '%'}">
                <div class="currentTime"><div class="interval-time-marker center "> <i class="icon icon-clock-o"></i> {{MarkerDate | formatTime}}</div></div>
            </div>

            <div class="day time-tick" v-for="bonchef in BonChefs" :style="{left: GetBonChefXPos(bonchef) + '%'}">
                <div :class="GetMarkerClassName(bonchef)"></div>
            </div>

            <div class="day time-tick" v-if="ShiftDate" :style="{left: ShiftDayTick.x + '%'}">
                <div class="shift-time">
                    <span>+{{ShiftDayDiff}}</span>
                </div>
            </div>

        </div>

        <!-----------------
        | BUTTONS RIGHT
        ------------------>
        <div class="ruler-controls controls-right">

            <div class="ruler-control-btn" v-on:click="plus(-1)">
                <i class='icon icon-min'></i>
                <span><translate item="TimelineSettings.ModifyTime.1Minute" /></span>
            </div>
          
            <div class="ruler-control-btn ruler-control-btn-pause" :class="{ 'enabled' : !disabled }" v-on:click="togglePause()">
                <span>
                    <i :class="{'icon' : 1, 'icon-pause-1' : !timelineSettings.pause, 'icon-play' : timelineSettings.pause}  "></i>
                </span>
            </div>

            <div class="ruler-control-btn" v-on:click="plus(1)">
                <i class='icon icon-plus-1'></i>
                <span><translate item="TimelineSettings.ModifyTime.1Minute" /></span>
            </div>

        </div>

    </div>
</template>

<script>

    import timeStore from '../repositories/TimeManager';
    import pauseDetail from '../components/PauseDetail';
    import Vue from 'vue';
    import Swal from "sweetalert2";
    import translate from '../components/translate'

    const Ruler = {

        //data: function () {
        //	return {
        //	//	MarkerDate: new Date()
        //	}
        //},

        components: { translate },

        data: function () {
            return {
                state: timeStore.state, zoom: timeStore.getZoom(),
                timelineSettings: this.$signalR.timelineSettings,                
                allert: null,
                timer: null,
                disabled : false
            };
        },

        props: {
            MarkerDate: { type: Date },
            ShiftDate: { type: Date },
            Markers: { type: Array },
            styleProp: { type: Object },
            BonChefs: { type: Array },
            ShowSlider: { type: Boolean, default: false }
        },

        methods: {
            GetBonChefXPos: function (bonchef) {
                return timeStore.calculateXPosition(bonchef.createdAtUtc);
            },

            GetMarkerClassName: function (bonchef) {
                let _class = 'bonchef-moment ';
                if (bonchef.confirmedAtUtc) {
                    _class += 'confirmed';
                } else {
                    _class += bonchef.createdAtUtc < Date.now() ? 'open' : 'future';
                }
                return _class;
            },

            plus: function (minutes) {
                this.$signalR.addMinutes(minutes);
            },

            setAutoscroll: function () {
                timeStore.state.autoScroll = true;

                // SCROLL TO - AND FLASH FIRST PLANNED RECEIPT
                var firstReceiptPlanned = document.querySelector(".reciept.accent0");
                if (firstReceiptPlanned) {

                    // determine top and scrollTo
                    var y = firstReceiptPlanned.getBoundingClientRect().top + window.scrollY - firstReceiptPlanned.clientHeight;
                    window.scrollTo({ top: y, behavior: 'smooth' });

                    // flash current receipt after scroll
                    setTimeout(function () {

                        var cssClass = 'highlightEffect';
                        var firstChildDiv = firstReceiptPlanned.querySelector("div:first-child");

                        // Function to toggle the flash effect
                        function toggleFlash() {
                            firstChildDiv.classList.toggle(cssClass);
                        }

                        // Add the flash effect class after a short delay
                        var flashInterval = setInterval(toggleFlash, 100);

                        // Clear the interval after a certain time
                        setTimeout(function () {
                            clearInterval(flashInterval);
                            firstChildDiv.classList.remove(cssClass); // Ensure the class is removed
                        }, 600);  // three time on-off (==200ms)

                    }, 600); // wait for smooth scroll

                }

            },

            togglePause: function () {               
                this.$signalR.setPause(!this.timelineSettings.pause);
            },

            zoomclick: function (zoomadd) {

                var zoom = timeStore.getZoom();
                zoom += zoomadd;

                if (zoom > 0) {
                    timeStore.setZoom(zoom);
                }

                this.timer = window.setInterval(function () {
                    var zoom = timeStore.getZoom();
                    zoom += zoomadd;
                    if (zoom > 0) {
                        timeStore.setZoom(zoom);
                    }
                }, 100);

            },
            zoomup: function () {
                window.clearInterval(this.timer);
            }

        },

        computed: {

            DayTick: function () {
                let x = timeStore.calculateXPosition(this.MarkerDate);
                return { x: x };
            },

            //ExtraTimeTick: function () {
            //    let x = timeStore.calculateXPosition(this.MarkerDate) + .2;
            //    return { x: x };
            //},

            //BonChefTick: function () {
            //    let x = timeStore.calculateXPosition(this.MarkerDate);
            //    return { x: x };
            //},

            ShiftDayTick: function () {
                if (this.ShiftDate) {
                    let x = timeStore.calculateXPosition(this.ShiftDate);
                    return { x: x };
                }
                return 0;
            },
            ShiftDayDiff: function () {
                if (this.ShiftDate) {
                    let diffMilliseconds = this.ShiftDate - this.MarkerDate;
                    let diffMinutes = Math.round(diffMilliseconds / (1000 * 60)); // Convert milliseconds to minutes and round
                    return diffMinutes;
                }
                return 0;
            }
        },
        watch: {

            "timelineSettings.pause": function (newval, oldval) {

                this.disabled = true;
                setTimeout(() => this.disabled = false, 4500);

                if (newval) {
                    // create orderDetail vue compnent
                    // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
                    var componentClass = Vue.extend(pauseDetail)
                    // set properties
                    var _pauseDetail = new componentClass({
                    });
                    _pauseDetail.$mount();

                    // https://sweetalert2.github.io/#configuration
                    this.$fire({
                        //title: "Bestelling #" + this.Order.orderNr,
                        html: '', // _orderDetail.$el.outerHTML,
                        width: '30rem',
                        padding: '0px',
                        showConfirmButton: false,
                        customClass: {
                            container: 'order-detail'
                        },
                        onOpen: function (ell) {
                            ell.children[1].appendChild(_pauseDetail.$el);
                        }
                    }).then(() => {
                        _pauseDetail.$destroy();
                    });
                }
                else {
                    Swal.close();
                }
            }
        },
        //, mounted: function () {
        //	var _this = this;


        //	//window.addEventListener("scroll", function () {
        //	//	if (window.pageYOffset > 140) {
        //	//		document.querySelector('.ruler').classList.add('fixed');
        //	//	}
        //	//	if (window.pageYOffset <= 140) {
        //	//		document.querySelector('.ruler').classList.remove('fixed');

        //	//	}
        //	//});

        //}
    };

    export { Ruler as default };

</script>
